import React from 'react';
import './product-box.scss';
import noImageAvailable from '../../images/products/no_image_book.jpg';
import { Link } from 'react-router-dom';
import { saveCart } from '../util/localStorage';
import { FaRegCheckCircle } from 'react-icons/fa';
import { storage } from '../../app-firebase/firebase';
import ReactLoading from 'react-loading';

/**
 * Event handler.
 * It will handle the click event whenever the user clicks on the "Add to cart"
 * button.
 * 
 * @param {Event object} e 
 * @param {any} id 
 */
// const handleAddToCart = (e, prod, updateCartStorage) => {
//    e.preventDefault();
//    saveCart(prod);
//    updateCartStorage();
   // let elem = document.getElementById('added-to-cart');
   // elem.style = {
   //    opacity: 1,
   //    display: 'block'
   // }
   // setTimeout(() => {
   //    elem.style = {
   //       opacity: 0,
   //       display: 'none'
   //    }
   // }, 1500)
// }

/**
 * ProductBox component
 * This component is an apresentation container for an individual product.
 * 
 * It contains the product's most important information for a quick
 * presentation. It also contains an "Add to cart" button to allow the user
 * to create a list of products inside the cart.
 * 
 * @param {object} props 
 */
class ProductBox extends React.Component {

   constructor(props) {
      super(props);

      this.state = {
         itemAdded: false,
         image: ''
      }

      this.handleAddToCart = this.handleAddToCart.bind(this);
   }

   componentDidMount() {
      try {
         if (this.props.product.image) {
            storage.ref().child(this.props.product.image[0]).getDownloadURL().then(url => {
                  this.setState({
                     image: url
                  });
            });
         }
      }
      catch(e) {
         console.error('The following error occurred: ' + e);
      }
      finally {

      }
   }

   componentDidUpdate() {
      try {
         if (this.props.product.image) {
            storage.ref().child(this.props.product.image[0]).getDownloadURL().then(url => {
               if (this.state.image !== url) {
                  this.setState({
                     image: url
                  });
               }
            });
         }
      }
      catch(e) {
         console.error('The following error occurred: ' + e);
      }
      finally {

      }
   }

   // componentWillUnmount() {
      
   // }


   /**
    * Event handler.
    * It will handle the click event whenever the user clicks on the "Add to cart"
    * button.
    * 
    * @param {Event object} e 
    * @param {any} id 
    */
   handleAddToCart = (e, prod, updateCartStorage) => {
      e.preventDefault();
      saveCart(prod);
      updateCartStorage();
      if (!this.state.itemAdded) {
         this.setState({
            itemAdded: !this.state.itemAdded
         });
         setTimeout(() => {
            this.setState({
               itemAdded: false
            })
         }, 2000);
      }
   }
   
   createProductTypeLegend() {
      let html = null;
      const type = this.props.product.type
      let msg = '';
      if (type === 'cd' || type === 'dvd') {
         msg = type.toUpperCase();
      }
      else {
         msg = type ? type.substring(0,1).toUpperCase() + type.substring(1) : null;
      }
      html = <p className="pb-type">{msg}</p>
      
      return html;
   }

   createCurrencyPrice() {
      if (this.props.currency === 'CAD') {
         return <p className="pb-price">CAD$ {this.props.product.priceCad.toFixed(2)}</p>
      }
      else {
         return <p className="pb-price">USD$ {this.props.product.priceUsd.toFixed(2)}</p>
      }
   }

   
   render() {
      const imageLink = '/products/' + this.props.product.ipNumber;
      let subtitle = this.props.product.subtitle;
      if (this.props.product.subtitle) {
         if (this.props.product.subtitle.length > 50) subtitle = this.props.product.subtitle.substring(0, 50) + '...';
      }
      let image = noImageAvailable;
      

      return (
         <div className="product-box">

            {this.state.itemAdded ? 
            <div className="added-to-cart d-flex flex-column apply-notice" id="added-to-cart">
               <div className="added-to-cart-inner">
                  <p><span><FaRegCheckCircle/></span></p>
                  <p>Item added to cart</p>
               </div>
            </div> : null}

            <div className="pb-image">
               {
                  // check if state.image is truthy, if so it renders the product image as a link
                  // or else it renders either loading component or default image
                  this.state.image ? 
                     <Link to={imageLink}>
                        <img src={this.state.image} alt={this.props.product.title} />
                     </Link> :
                     // if props.product.image is set renders a loading component, if not
                     // renders a default image
                     (this.props.product.image ? 
                        <div className="d-flex flex-row justify-content-center align-items-center pb-image-loading" style={{minHeight: '15rem'}}>
                           <ReactLoading type={'spin'} color="#2D3142" />
                        </div> :
                        <Link to={imageLink}>
                           <img src={image} alt={this.props.product.title} />
                        </Link>)
                     
               }
               
            </div>

            <div className="pb-title">
               <Link to={imageLink}>{this.props.product.title}</Link>
            </div>
            {this.props.product.subtitle ? <Link to={imageLink} className="pb-subtitle">{subtitle}</Link> : null}
            <p className="pb-author">{this.props.product.author ? `By ${this.props.product.author}` : ''}</p>
            <div className="pb-space"></div>
            {this.createProductTypeLegend()}
            {this.createCurrencyPrice()}
            <div className="pb-addtocart-button" onClick={(e) => this.handleAddToCart(e, this.props.product, this.props.updateCartStorage)}>
               {/* addtocart-button */}
               <button className="btn btn-success btn-block">Add to cart</button>
            </div>
         </div>
      )
   }
}

export default ProductBox;